<template>
    <div class="lg:ml-5 mt-5 lg:mt-0 w-full lg:w-72 flex-shrink-0">
        <AccountDetails :user="user" />
        <ContactDetails :user="user" />
    </div>
</template>

<script>
import AccountDetails from "@/Components/User/Account/Details";
import ContactDetails from "@/Components/User/Contact/Details";

export default {
    props: ['user'],
    components: {AccountDetails, ContactDetails}
}
</script>
